import React from 'react';
import AppCard from './AppCard';
import styles from './Apps.module.css';
import compyzIcon from '../assets/compyz-icon.png';
import beatClickerIcon from '../assets/beatclicker-icon.jpg';

const appsData = [
  {
    icon: compyzIcon,
    iconIsImage: true,
    name: 'Compyz',
    slug: 'compyz',
    status: 'READY TO LAUNCH',
    tagline: 'A lightweight, AI-powered app designed for one thing: getting instant price estimates on collectible cards when seconds matter. Perfect for online live auctions where speed is everything.',
    subtitle: 'WHY COMPYZ IS DIFFERENT',
    features: [
      'Screenshot capture feature—automatically analyzes your latest screenshot',
      'Price results in seconds, not minutes',
      'Works with cards that have background noise or clutter',
      'No collection management bloat—just fast, accurate pricing',
      'No multiple API calls slowing you down',
      'Built for auction speed, not collection tracking',
    ],
    links: [
      { text: 'Coming Soon', url: '#', disabled: true },
    ],
  },
  {
    icon: beatClickerIcon,
    iconIsImage: true,
    name: 'Beat Clicker',
    slug: 'beat-clicker',
    status: 'READY TO LAUNCH',
    tagline: "A simple, addictive clicker game that tests your memory and concentration. One button, endless sequences. That's it. No ads, no complexity—just pure brain-stimulating fun.",
    subtitle: 'KEEP IT SIMPLE',
    features: [
      'One-button gameplay—the app gives a sequence, you tap it back',
      'Tests concentration, memory, and rhythm',
      'Completely ad-free experience',
      'Unlock button skins with in-game credits and experience',
      'Some premium skins available for purchase',
      'Relaxing yet mentally stimulating',
    ],
    links: [
      { text: 'Coming Soon', url: '#', disabled: true },
    ],
  },
  {
    icon: '🔧',
    name: 'Fixscope',
    slug: 'fixscope',
    status: 'IN DEVELOPMENT',
    statusClass: 'inDevelopment',
    tagline: 'AI-powered diagnostic tool for mechanical and electronic problems. Get repair suggestions, detailed analysis, and locate the parts you need—all from your phone. Built for professionals and DIY enthusiasts alike.',
    subtitle: 'COMING SOON',
    features: [
      'AI-driven diagnosis for mechanical and electronic issues',
      'Detailed repair suggestions and step-by-step guidance',
      'Parts location and identification',
      'Comprehensive problem analysis',
      'Designed for both commercial and personal use',
    ],
    links: [
      { text: 'Coming Soon', url: '#', disabled: true },
    ],
  },
];

function Apps() {
  return (
    <section id="apps" className={styles.appsSection}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Our Applications</h2>
        <p className={styles.intro}>
          Three distinct apps, each designed to make your life easier or more enjoyable. Built with purpose, powered by experience.
        </p>

        {appsData.map((app, index) => (
          <AppCard key={index} {...app} />
        ))}
      </div>
    </section>
  );
}

export default Apps;
